export default __webpack_public_path__ + "static/popup-anim-ec0cb98e25bb4d627eed36a5ca62ad71.gif";